<ul id="past-due-payments" class="list-group list-group-flush pay-list">
    @if ((!payments || (payments.length <= 0))) { 
        <li class="list-group-item">No past due payments at this time.</li>
    }
    
    @for (payment of pastDues; track payment) {
        <li class="list-group-item" [ngClass]="{'active': (payment.termsId == termsId)}" (click)="selected($event, payment)">
            <p class="due {{dueToClass(payment.due)}}">{{daysPastDue(payment.due)}}d</p>
            <div class="text-truncate">
                <p class="title">{{payment.contact}}</p>
                <p class="subtitle">{{payment.stock}} {{payment.vehicle}}</p>
                @if (payment.insurance) {
                    <p class="alert alert-{{payment.insuranceClass}} text-truncate">{{payment.insurance | lowercase}}</p>
                }
            </div>
            @if (payment.workable) {
                <div class="currency d-none d-lg-block">
                    <p class="title">{{payment.amount | currency}}</p>
                    <p class="subtitle">{{payment.categories.join(', ')}}</p>
                </div>
            }
            @else {
                <p class="worked"><span class="material-icons">check_circle_outline</span> {{daysPastDue(payment.worked)}}d ago</p>
            }
        </li>
    }
</ul>